export const registerAccordion = () => {
    const elements = document.querySelectorAll('.accordion>button')
    const answerElements = document.querySelectorAll('.accordion .answer')

    elements.forEach((element, index) =>
        element.addEventListener('click', () => {
            const isOpen = element.classList.contains('open')

            if (isOpen) {
                element.classList.remove('open')
                answerElements[index].style.maxHeight = null
            } else {
                element.classList.add('open')
                answerElements[index].style.maxHeight =
                    answerElements[index].scrollHeight + 'px'
            }

            elements.forEach((el, idx) => {
                if (idx !== index) {
                    el.classList.remove('open')
                    answerElements[idx].style.maxHeight = null
                }
            })
        })
    )

    // setup first open panel
    const openElement = [...elements].filter((element) =>
        element.classList.contains('open')
    )
    const openAnswer = openElement[0].querySelector('.answer')

    openAnswer.style.maxHeight = openAnswer.scrollHeight + 'px'
}
